import { connect } from 'react-redux';
import { compose, withProps, renderNothing, branch, renderComponent, withHandlers } from 'recompose';

import BrandDaysOffOn from '../components/BrandDaysOffOn';
import { selector } from '../helpers';
import {
  canUserModifyBarbers,
  canUserModifySchedules,
  canUserViewSchedules,
} from '../../../../../common/helpers/users';
import { LOCATIONS_ALL_ID } from '../../../containers/BrandBarber/constants';
import AllOrEmptyLocations from '../components/AllOrEmptyLocations';

import { getCalendarDayWithConflicts, getDaysOnWithConflicts } from '../../../scheduleConflictsHelpers';
import { addBrandBarberDayOff, removeBrandBarberDayOff } from '../../../actions/brand';


const DaysOffOnContainer = compose(
  connect((state, ownProps) => ({
    daysOff: selector(state, `${ownProps.selectedLocation}.days_off`),
    formDaysOn: selector(state, `${ownProps.selectedLocation}.days_on`),
    barberId: selector(state, `${ownProps.selectedLocation}.id`),
  }), {
    addBrandBarberDayOff,
    removeBrandBarberDayOff,
  }),
  withProps(
    props => ({
      canModify: canUserModifyBarbers(props.permissions) && canUserModifySchedules(props.permissions),
      daysOn: props.selectedLocation === LOCATIONS_ALL_ID
        ? props.formDaysOn
        : getDaysOnWithConflicts({
          daysOn: props.formDaysOn,
          brandBarber: props.formValues,
          shop: props.barberShops.find(barberShop => barberShop.id === props.selectedLocation),
          shopNamesById: props.shopNamesById,
        }),
    })
  ),
  withHandlers({
    getCalendarDayWithConflicts: (props) => {
      const shop = props.barberShops.find(barberShop => barberShop.id === props.selectedLocation);
      const brandBarber = props.formValues;
      const shopNamesById = props.shopNamesById;

      if (props.selectedLocation === LOCATIONS_ALL_ID) {
        return day => ({ day });
      }

      return calendarDay => getCalendarDayWithConflicts({
        calendarDay,
        brandBarber,
        shop,
        shopNamesById,
      });
    },
    onDayOffAdded: props => (dayOffIndex, dayOff) =>
      props.addBrandBarberDayOff(props.selectedLocation, dayOffIndex, dayOff),
    onDayOffRemoved: props => dayOffIndex => props.removeBrandBarberDayOff(props.selectedLocation, dayOffIndex),
  }),
  branch(
    props => !canUserViewSchedules(props.permissions),
    renderNothing,
  ),
  branch(
    props =>
      !props.selectedLocation ||
      props.selectedLocation === LOCATIONS_ALL_ID,
    renderComponent(AllOrEmptyLocations),
  ),
)(BrandDaysOffOn);

export default DaysOffOnContainer;
